import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import WarroomService from '@/services/WarroomService';
import { removeStoredValue, writeStoredJson } from '@/utils/storage';

const { AccountsService } = WarroomService;

export function getAccounts({ state, commit }) {
  if (state.accounts && state.accounts.length) {
    commit(MUTATE_MULTIPLE, [{
      property: 'requestStatus',
      with: 'success',
    }, {
      property: 'loadingHistory',
      with: true,
    }, {
      property: 'historyIsLoaded',
      with: false,
    }]);
    return Promise.resolve(state.accounts);
  }

  commit(MUTATE_MULTIPLE, [{
    property: 'requestStatus',
    with: 'loading',
  }, {
    property: 'loadingHistory',
    with: true,
  }, {
    property: 'historyIsLoaded',
    with: false,
  }]);

  return AccountsService.find()
    .then(data => {
      const { message } = data;
      commit(MUTATE_MULTIPLE, [{
        property: 'requestStatus',
        with: 'success',
      }, {
        property: 'accounts',
        with: message,
      }]);
      if (message.length >= 1) {
        const matched = state.activeAccount &&
          message.find(a => a.id === state.activeAccount.id);
        commit(MUTATE, {
          property: 'activeAccount',
          with: matched || null,
        });
        if (!matched) {
          removeStoredValue('admin_selectedAccount');
        }
      } else {
        commit(MUTATE, {
          property: 'activeAccount',
          with: null,
        });
        removeStoredValue('admin_selectedAccount');
      }

      return Promise.resolve(message);
    }).catch((e) => {
      console.error(e);
      commit(MUTATE, {
        property: 'requestStatus',
        with: 'error',
      });
    });
}

export function setAccount({ commit }, { selectedAccount }) {
  if (selectedAccount) {
    writeStoredJson('admin_selectedAccount', selectedAccount);
  } else {
    removeStoredValue('admin_selectedAccount');
  }
  commit(MUTATE, {
    property: 'activeAccount',
    with: selectedAccount,
  });
}

export function unsetAccount({ commit }) {
  removeStoredValue('admin_selectedAccount');
  commit(MUTATE, {
    property: 'activeAccount',
    with: null,
  });
}
export function getUsergroups({ state, commit }) {
  let usergroups = state.usergroups;
  const accounts = state.accounts;
  accounts.forEach(account => {
    if (!usergroups.find(usergroup => usergroup.name === account.group)) {
      usergroups = [...usergroups, { name: account.group }];
    }
  });
  commit(MUTATE_MULTIPLE, [{
    property: 'requestStatus',
    with: 'success',
  }, {
    property: 'usergroups',
    with: usergroups,
  }]);
  const selectedUsergroup = state.activeUsergroup &&
    usergroups.find(usergroup => usergroup.name === state.activeUsergroup.name);
  const activeUsergroup = selectedUsergroup || null;
  if (activeUsergroup) {
    writeStoredJson('admin_selectedUsergroup', activeUsergroup);
  } else {
    removeStoredValue('admin_selectedUsergroup');
  }
  commit(MUTATE, {
    property: 'activeUsergroup',
    with: activeUsergroup,
  });
}

export function setUsergroup({ commit }, { selectedUsergroup }) {
  if (selectedUsergroup) {
    writeStoredJson('admin_selectedUsergroup', selectedUsergroup);
  } else {
    removeStoredValue('admin_selectedUsergroup');
  }
  commit(MUTATE, {
    property: 'activeUsergroup',
    with: selectedUsergroup,
  });
}
